import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-signup-complete',
  templateUrl: './signup-complete.component.html',
})
export class SignupCompleteComponent implements OnInit {
  @Output() switchAuthMode: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
